import styled from '@emotion/styled';
import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';
import { dropdownWrapper } from 'src/assets/colors';
import { SelectOptionType } from './CountryDropdownNew.state';
import FLAGS from './assets/flags.png';

export const countryDropdownStyles: StylesConfig<SelectOptionType, false> = {
    control: (base) => ({
        ...base,
        minHeight: '40px',
        height: '40px',
        borderRadius: '0',
        marginBottom: '8px',
    }),
    valueContainer: (base) => ({
        ...base,
        height: '40px',
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
    }),
    singleValue: (base) => ({
        ...base,
        position: 'static' as const,
        transform: 'none',
        margin: 0,
        maxWidth: '100%',
    }),
    placeholder: (base) => ({
        ...base,
        position: 'static' as const,
        transform: 'none',
        margin: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '40px',
    }),
};

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean }>`
    background-color: ${(props): string =>
        props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColor};
    color: ${(props): string =>
        props.isSelected === true ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    padding: 8px 10px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    font-weight: 400;
    white-space: nowrap;
    vertical-align: middle;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${(props): string =>
            props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColorHover};
        color: ${dropdownWrapper.option.txtColorSelected};
    }
`;

export const CountryItemWrapper = styled('span', { label: 'CountryItemWrapper' })`
    align-items: center;
    display: flex;
    gap: 4px;
    justify-content: start;
`;

export const CountryItem = styled('i', { label: 'CountryItem' })`
    background-image: url(${FLAGS});
    background-repeat: no-repeat;
    background-size: 224px 199px;
    display: inline-block;
    height: 11px;
    width: 16px;
    vertical-align: middle;
`;

export const PersonalDetailsDropdownWrapper = styled('div', { label: 'PersonalDetailsDropdownWrapper' })`
    margin-bottom: 16px;
    width: 100%;
    
    &:last-of-type {
        margin-bottom: 0;
    }
`;
